import https from './index'
import qs from 'qs'
import  URLS from "./lz.js"

// 比分系统

// 本地开发环境

// URLS.ScoreMatch = 'http://192.168.0.153:2302'

/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询比赛列表被关联的主播信息
 */
export function matchListBeRelevanceAnchorList(params) {
    return https({
        url:URLS.ScoreMatch + '/match/matchListBeRelevanceAnchorList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 赛果 - 比赛列表 (V3版本）
 */
export function resultsListV3(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/resultsListV3',
        method: "get",
        // responseType: 'arraybuffer', // 注意这个参数必须加，不然会出现下载好的文件打开是乱码情况,这个参数是为了告诉axios请求，请求的是二进制数据流
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 赛程 - 比赛列表 (V3版本)
 *
 *
 */
export function willListV3(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/willListV3',
        method: "get",
        // responseType: 'arraybuffer', // 注意这个参数必须加，不然会出现下载好的文件打开是乱码情况,这个参数是为了告诉axios请求，请求的是二进制数据流
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 即时 - 比赛列表 (V3版本)
 *
 *
 */
export function timelyListV3(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/timelyListV3',
        method: "get",
        // responseType: 'arraybuffer', // 注意这个参数必须加，不然会出现下载好的文件打开是乱码情况,这个参数是为了告诉axios请求，请求的是二进制数据流
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询热门比赛列表
 */

export function matchHotList(params) {
    return https({
        url:URLS.ScoreMatch + '/match/hotList',
        method: "get",
        authToken:true,
        params,
    })
}

//



//
/**
 *
 * @param {roomId} params
 * @returns
 * @description 指数汇总
 */
export function companyOddsCollectList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/odds/companyOddsCollectList',
        method: "get",
        authToken:true,
        params,
    })
}
// 亚盘

/**
 *
 * @param {roomId} params
 * @returns
 * @description 亚盘 - 指数流水
 */
export function asiaFlowList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/odds/asiaFlowList',
        method: "get",
        authToken:true,
        params,
    })
}
// 大小球

/**
 *
 * @param {roomId} params
 * @returns
 * @description 大小球 - 指数流水
 */
export function bsFlowList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/odds/bsFlowList',
        method: "get",
        authToken:true,
        params,
    })
}
// 欧赔


/**
 *
 * @param {roomId} params
 * @returns
 * @description 欧赔 - 指数流水
 */
export function europeFlowList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/odds/europeFlowList',
        method: "get",
        authToken:true,
        params,
    })
}
//
/**
 *
 * @param {roomId} params
 * @returns
 * @description 球队出场阵容/伤停数据
 */
export function teamLineUp(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamLineUp',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询球队近期战绩分析数据
 */
export function teamRecentRecord(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamRecentRecord',
        method: "get",
        authToken:true,
        params,
    })
}

//

//
/**
 *
 * @param {roomId} params
 * @returns
 * @description 球队的联赛积分排名
 *
 */

export function teamLeagueRank(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamLeagueRank',
        method: "get",
        authToken:true,
        params,
    })
}

//



/**
 *
 * @param {roomId} params
 * @returns
 * @description 球队的未来赛事
 *
 */

export function futureMatchList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/futureMatchList',
        method: "get",
        authToken:true,
        params,
    })
}





/**
 *
 * @param {roomId} params
 * @returns
 * @description 球队的历史交锋
 *
 */

export function teamHistoryConfrontation(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamHistoryConfrontation',
        method: "get",
        authToken:true,
        params,
    })
}




/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询主播最新关联的比赛信息
 *
 */

export function matchlastRelevance(params) {
    return https({
        url:URLS.ScoreMatch + '/match/lastRelevance',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询热门比赛被关联的主播列表
 *
 */

export function matchBeRelevanceAnchorList(params) {
    return https({
        url:URLS.ScoreMatch + '/match/matchBeRelevanceAnchorList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询热门比赛被关联的主播列表
 *
 */

export function hotMatchBeRelevanceAnchorList(params) {
    return https({
        url:URLS.ScoreMatch + '/match/hotMatchBeRelevanceAnchorList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description - 球队胜平负分析数据
 *
 */

export function teamHtAnalysis(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamHtAnalysis',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns
 * @description - 比赛直播详情
 *
 */

export function matchDetail(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/matchDetail',
        method: "get",
        authToken:true,
        params,
    })
}




/**
 *
 * @param {roomId} params
 * @returns
 * @description 主播关联比赛
 */
export function matchRelevance(data) {
    return https({
        url:URLS.ScoreMatch + '/match/relevance',
        method: "post",
        authToken:true,
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询指定联赛信息
 */
export function matchrecentList(params) {
    return https({
        url:URLS.ScoreMatch + '/match/recentList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询最近比赛信息
 */
export function recentList(params) {
    return https({
        url:URLS.ScoreMatch + '/league/recentList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 计时比赛列表
 */
export function timelyList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/timelyList',
        method: "get",
        authToken:true,
        params,
    })
}

//


/**
 *
 * @param {roomId} params
 * @returns
 * @description - 球队技术统计
 */
export function teamTechStatistic(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/teamTechStatistic',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 计时筛选
 */
export function leagueFiltrate(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/filtrate/leagueFiltrate',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns
 * @description 比赛事件列表
 */
export function matchInnerEvent(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/matchInner/eventList',
        method: "get",
        authToken:true,
        params,
    })
}

//

/**
 *
 * @param {roomId} params
 * @returns
 * @description 赛果比赛列表
 */
export function resultsList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/resultsList',
        method: "get",
        authToken:true,
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 赛果比赛列表
 */
export function matchWillList(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/match/willList',
        method: "get",
        authToken:true,
        params,
    })
}



/*

 *
 * @param {roomId} params
 * @returns
 * @description 查询热门联赛信

 */
export function hotList(params) {
    return https({
        url:URLS.ScoreMatch + '/league/hotList',
        method: "get",
        authToken:true,
        params,
    })
}




/*

 *
 * @param {roomId} params
 * @returns
 * @description 查询热门联赛信

 */
export function leagueRank(params) {
    return https({
        url:URLS.ScoreMatch + '/fb/league/leagueRank',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {anchorUId}  主播id
 * @returns
 * @description 获取资讯信息评论
 */
export function getcommentList(params) {
	// opt.header['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return https({
        url:URLS.FansGroupUrl + '/article/operation/commentList',
        method: "get",
        params,
        authToken:true,
      })
}



// WEBPACK FOOTER //
// ./src/api/scope.js